import { render, staticRenderFns } from "./DiskWraper.vue?vue&type=template&id=ff23acce"
import script from "./DiskWraper.vue?vue&type=script&lang=js"
export * from "./DiskWraper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports